export default function (units) {
  const totalPx = 8 * units;
  return `${totalPx}px`;
}
